/**
 * BT-045 — Checklist réception contenu client officiel (préparation, sans import réel).
 */
export const CLIENT_CONTENT_RECEPTION_BT = "BT-GSD-KARATE-FINALISATION-PHASE1-CONTENU-CONFORMITE-IMPORT-OFFICIEL-045";

export const CLIENT_CONTENT_CHECKLIST = [
  {
    id: "dojos-10",
    labelFr: "10 dojos officiels (nom, ville, adresse, contact)",
    labelEn: "10 official dojos (name, city, address, contact)",
    modelSection: "dojos",
  },
  {
    id: "instructeurs",
    labelFr: "Liste instructeurs / Sensei",
    labelEn: "Instructors / Sensei list",
    modelSection: "instructeurs",
  },
  {
    id: "sempai",
    labelFr: "Liste assistants / Sempai",
    labelEn: "Assistants / Sempai list",
    modelSection: "sempai",
  },
  {
    id: "etudiants",
    labelFr: "Liste étudiants par dojo",
    labelEn: "Students per dojo",
    modelSection: "etudiants",
  },
  {
    id: "parents",
    labelFr: "Liens parents / enfants",
    labelEn: "Parent / child links",
    modelSection: "parents",
  },
  {
    id: "grades",
    labelFr: "Grades actuels (ceintures)",
    labelEn: "Current grades (belts)",
    modelSection: "grades",
  },
  {
    id: "titres",
    labelFr: "Titres / reconnaissances",
    labelEn: "Titles / recognitions",
    modelSection: "titres",
  },
  {
    id: "documents-pdf",
    labelFr: "Documents publics PDF",
    labelEn: "Public PDF documents",
    modelSection: "documents",
  },
  {
    id: "textes-officiels",
    labelFr: "Textes officiels (à propos, mission, organisation)",
    labelEn: "Official texts (about, mission, organization)",
    modelSection: null,
  },
  {
    id: "coordonnees",
    labelFr: "Coordonnées officielles de contact",
    labelEn: "Official contact coordinates",
    modelSection: null,
  },
  {
    id: "autorisation",
    labelFr: "Autorisation d'utilisation des informations",
    labelEn: "Authorization to use information",
    modelSection: null,
  },
  {
    id: "traductions",
    labelFr: "Validation des traductions FR/EN si nécessaire",
    labelEn: "FR/EN translation validation if needed",
    modelSection: null,
  },
];

export function getClientContentChecklist(locale = "fr") {
  const isEn = locale === "en";
  return CLIENT_CONTENT_CHECKLIST.map((item) => ({
    id: item.id,
    label: isEn ? item.labelEn : item.labelFr,
    modelSection: item.modelSection,
  }));
}
